// Follow-up queue (pages/Followups.jsx), contact log (components/ContactDialog.jsx), confirmation badges.
const strings = {
  es: {
    followups_sub: "Confirma las próximas citas, da seguimiento a pacientes y cierra las citas pendientes.",
    fu_confirmar: "Por confirmar",
    fu_seguimiento: "Seguimientos",
    fu_no_asistio: "No asistieron",
    fu_sin_cerrar: "Sin cerrar",
    fu_confirmar_desc: "Citas de hoy y los próximos 2 días que el paciente aún no ha confirmado.",
    fu_seguimiento_desc: "Contactos que programaste para hoy o que ya están vencidos.",
    fu_no_asistio_desc: "Pacientes que faltaron en los últimos 30 días y aún no tienen una nueva cita.",
    fu_sin_cerrar_desc: "Citas que ya pasaron y siguen como «Agendada». Indica qué ocurrió.",
    fu_empty: "Todo al día. No hay pendientes en esta lista.",
    conf_pending: "Sin confirmar",
    conf_confirmed: "Confirmada",
    conf_no_answer: "No contesta",
    conf_reschedule: "Quiere reagendar",
    ch_call: "Llamada",
    ch_whatsapp: "WhatsApp",
    ch_sms: "SMS",
    ch_email: "Correo",
    ch_in_person: "En persona",
    res_confirmada: "Confirmó",
    res_no_contesta: "No contestó",
    res_reagendar: "Pidió reagendar",
    res_cancelada: "Canceló",
    res_nota: "Solo nota",
    res_cancel_hint: "La cita se marcará como cancelada.",
    log_contact: "Registrar contacto",
    log_contact_desc: "Anota cada intento de contacto con el paciente para que todo el equipo vea el historial.",
    confirm_or_log: "Confirmar / registrar",
    send_whatsapp: "Enviar WhatsApp",
    no_phone: "Sin teléfono registrado",
    channel: "Medio",
    result: "Resultado",
    contact_notes_ph: "Ej. Dejé mensaje de voz; prefiere que le llamen por la tarde.",
    next_followup: "Próximo seguimiento",
    next_followup_hint: "Opcional. Aparecerá en «Seguimientos» ese día.",
    recommended: "recomendado",
    contact_history: "Historial de contactos",
    contact_saved: "Contacto registrado",
    followup_on: "Seguimiento",
    last_contact: "Último contacto",
    reschedule: "Reagendar",
  },
  en: {
    followups_sub: "Confirm upcoming appointments, follow up with patients and close pending appointments.",
    fu_confirmar: "To confirm",
    fu_seguimiento: "Follow-ups",
    fu_no_asistio: "No-shows",
    fu_sin_cerrar: "Not closed",
    fu_confirmar_desc: "Appointments today and in the next 2 days that the patient hasn't confirmed yet.",
    fu_seguimiento_desc: "Contacts you scheduled for today or that are overdue.",
    fu_no_asistio_desc: "Patients who missed an appointment in the last 30 days and haven't rebooked.",
    fu_sin_cerrar_desc: "Past appointments still marked “Scheduled”. Record what happened.",
    fu_empty: "All caught up. Nothing pending in this list.",
    conf_pending: "Not confirmed",
    conf_confirmed: "Confirmed",
    conf_no_answer: "No answer",
    conf_reschedule: "Wants to reschedule",
    ch_call: "Call",
    ch_whatsapp: "WhatsApp",
    ch_sms: "SMS",
    ch_email: "Email",
    ch_in_person: "In person",
    res_confirmada: "Confirmed",
    res_no_contesta: "No answer",
    res_reagendar: "Asked to reschedule",
    res_cancelada: "Cancelled",
    res_nota: "Note only",
    res_cancel_hint: "The appointment will be marked as cancelled.",
    log_contact: "Log contact",
    log_contact_desc: "Record every attempt to reach the patient so the whole team sees the history.",
    confirm_or_log: "Confirm / log",
    send_whatsapp: "Send WhatsApp",
    no_phone: "No phone on file",
    channel: "Channel",
    result: "Result",
    contact_notes_ph: "E.g. Left a voicemail; prefers calls in the afternoon.",
    next_followup: "Next follow-up",
    next_followup_hint: "Optional. It will show under “Follow-ups” that day.",
    recommended: "recommended",
    contact_history: "Contact history",
    contact_saved: "Contact logged",
    followup_on: "Follow-up",
    last_contact: "Last contact",
    reschedule: "Reschedule",
  },
};

export default strings;
